<template lang="pug">
    v-bottom-navigation(light :background-color='color' color="#008e95" fixed v-model="value" ).custom-bottom-nav.d-flex.justify-content
      v-btn(  large icon fab v-for="item in itemsBottomNavContributor" @click='goTo(item.to)').custom-bottom-nav__btn
        v-badge(v-if="cartTotalProducts > 0 && item.name === 'Canasta'" color="red" overlap="" bordered="" style="position: initial !important;")
          template(v-slot:badge="")
            span(style="bottom: calc(100% - 13px);left: calc(100% - 30px);") {{ cartTotalProducts }}
        span {{item.name}}
        v-icon {{item.icon}}
</template>

<script>
  export default {
    name: 'BottomNav',
    data () {
      return {
        value: 0,
        color: '#fff',
        itemsBottomNavContributor: [
          {
            to: '/',
            name: 'home',
            icon: 'mdi-home',
            iconActive: require('@/assets/icons/home.png'),
          },
          /* {
            to: '/cart',
            name: 'Canasta',
            icon: 'mdi-cart',
            iconActive: require('@/assets/icons/bottom/order.png'),
          }, */
          {
            to: '/search',
            name: 'Buscar',
            icon: 'mdi-magnify',
            iconActive: require('@/assets/icons/search.png'),
          },
          {
            to: '/notifications',
            name: 'Notificaciones',
            icon: 'mdi-bell',
            iconActive: require('@/assets/icons/notifications.png'),
          },
          {
            to: '/profile',
            name: 'Mi Perfil',
            icon: 'mdi-account',
            iconActive: require('@/assets/icons/profile.png'),
          },
        ],
      }
    },
    computed: {
      user () {
        return this.$store.state.users.user
      },
      cartTotalProducts () {
        const vm = this
        let totalProducts = 0
        vm.$store.getters['pos/getCart'].forEach(store => {
          store.inventory.forEach(product => {
            // console.log(product)
            if (product.data.magnitude) {
              totalProducts += 1
            } else {
              totalProducts += product.amount
            }
          })
        })
        // console.log(totalProducts)
        return totalProducts
      },
    },
    watch: {
      $route (newVal, oldVal) {
        const vm = this
        if (newVal.name === 'home') {
          vm.value = 0
        } else if (newVal.name === 'search' || newVal.name === 'shop') {
          vm.value = 1 // 2
        } else if (newVal.name === 'notifications') {
          vm.value = 2 // 3
        } else if (newVal.name === 'Perfil') {
          vm.value = 3 // 4
        } /* else if (newVal.name === 'cart') {
          vm.value = 1
        } */
      },
    },
    created () {
      const vm = this
      if (vm.$route.name === 'home') {
        vm.value = 0
      } else if (vm.$route.name === 'search' || vm.$route.name === 'shop') {
        vm.value = 1 // 2
      } else if (vm.$route.name === 'notifications') {
        vm.value = 2 // 3
      } else if (vm.$route.name === 'Perfil') {
        vm.value = 3 // 4
      } /* else if (vm.$route.name === 'cart') {
        vm.value = 1
      } */
    },
    methods: {
      openDialog (dialog) {
        this.$store.dispatch('dialogs/openDialog', dialog).then(function () {
          // // console.log('dialog set on : ' + dialog)
        })
      },
      goTo (to) {
        // console.log(to)
        if (!this.user) {
          switch (to) {
            case '/notifications':
              this.openDialog('login')
              break
            case '/profile':
              this.openDialog('login')
              break
            default:
              this.$router.push(to)
              break
          }
        } else {
          this.$router.push(to)
        }
      },
    },
  }
</script>
<style scoped lang="scss">
  .v-btn--active{
   .v-icon  {
     color: #008e95;
   }
  }
  .custom-bottom-nav {
    margin: 0 !important;
    background: #00CAE3;
  }
</style>
